declare var pglob : IPhotometerGlobalVar;


module shoppinglist {
  'use strict';

  


	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class ShoppingListCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      'shoppingListService', 
      '$timeout',
      '$element',
      '$window', 
      '$mdDialog',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IShoppingListCtrlScope,
      private shoppingListService: IShoppingListService,
      private $timeout: ng.ITimeoutService,
      private $element: ng.IRootElementService,
      private $window: ng.IWindowService,
      private $mdDialog: ng.material.IDialogService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;


      var watcher = {};
      var addWatcher = (listId?) : void => {
        if (!listId) {
          for(var key in this.$scope.lists) {
            addWatcher(key);
          }
          return;
        }

        if (!watcher[listId]) {
          watcher[listId] = this.$scope.$watch('lists[\'' + listId + '\'].dirty', 
            (newVal, oldVal) => {
              if (newVal != oldVal && this.$scope.lists[listId].dirty) {
                this.$scope.lists[listId].dirty = false;
                this.$scope.requestOnGoing = true;
                this.shoppingListService.updateQtyDebounced(listId);                
              }
            }, true);
        }
      }

      $scope.vm = this;
      $scope.hl = pglob.RouteData.CurrentLanguage.hl;

     
      
      var SHOPPINGLIST_TYPE = 1;
      var CART_TYPE = 2;
      $scope.dirty = {};


      //init
      var dataEl = document.getElementById('cart-data');
      var serverState :ServerState;
      if (dataEl) {
        serverState = JSON.parse(dataEl.innerHTML);
      } 

      if (serverState) {          
        this.$scope.Updating = this.shoppingListService.checkForUpdates(serverState, () => {
          this.$scope.Updating = false;
        });
      }

      shoppingListService.subscribeOnShowChange($scope, (event, type, target) => {
        $scope.showType = type;

        if (type) {
          $($element).css({
            left:  ($(target).closest('.page-el')[0] as Element).getBoundingClientRect().right - $($element).width()
          });
          $($element).find('nav li').css({
            right:  ($(target).closest('.page-el')[0] as Element).getBoundingClientRect().right - ($(target)[0] as Element).getBoundingClientRect().right - 2
          });
        }

      });



      $scope.lists = shoppingListService.getLists() || {};
      addWatcher();
           
      var clipWidth = $(".cart-box .clip").width(); 
      var cartWidth = $(".cart-box").outerWidth() - clipWidth;
      var pageWidth = $("#page").width();

      $scope.toggleCart = () => {
        $scope.PulledOut = !$scope.PulledOut;
        this.shoppingListService.setLocalSetting('PulledOut', $scope.PulledOut);

        var offset = pageWidth - cartWidth - clipWidth;
        
        if ($scope.PulledOut) {
          offset = pageWidth;
        } 

        var sl = $(window).scrollLeft();
        if (!$scope.PulledOut) {
          sl = Math.max(0, pageWidth + clipWidth - $(window).width());
        }

        
        $('.cart-box').animate({ 'margin-left': offset - sl }, 800, 'easeOutQuart', function() { /*$(window).scroll()*/ });
        $('body > div').animate({ 'width': offset + cartWidth + 2 * clipWidth }, 1000, 'easeOutQuart', function() { 
          if ($scope.PulledOut && $(window).width() < pageWidth + cartWidth + clipWidth) {
            $(window).scrollLeft(Math.max(0, pageWidth + clipWidth + 2 * cartWidth - $(window).width()));
          } else {
            $(window).scroll();
          }
        });

        //$('.cart-box').css({ 'margin-left': offset });
        //$('body > div').css({ 'width': offset + cartWidth + 2 * clipWidth });
         
      }; 
      
      $(document).ready(function() {  

        if ($(".cart-box")) {
          $(window).scroll(function(){
            $('.cart-pulled-in').css({
                'margin-left': pageWidth - cartWidth - clipWidth - $(this).scrollLeft()
            });

            $('.cart-pulled-out').css({
                'margin-left': pageWidth - $(this).scrollLeft()
            });
          });

          $('.cart-content').css({
              'max-height': $(window).height() - 50
          });

          $(window).resize(function() {
            $('.cart-content').css({
              'max-height': $(window).height() - 50
            });
          });
        }
      }); 

      $scope.$on('cartUpdated', function(event, data) { 
        var listId = data.ID
	      $scope.requestOnGoing = false;
        if (!$scope.$$phase) $scope.$apply();
        addWatcher(listId);
      });
     

    }

    getListByType(type) {
      for (var key in this.$scope.lists) {
        if (this.$scope.lists[key] && this.$scope.lists[key].Type === type) return this.$scope.lists[key];
      } 
      return null;
    }     
    
    getTotalQty(list) {
      return this.shoppingListService.getTotalQty(list);
    };


    hideOverlay() {
      this.shoppingListService.hide();
    }

    openDetailModal(ev: MouseEvent, part: part.Part) : void {

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'PartDetailCtrl',
        templateUrl: 'part/PartDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          partId: part.ID,
          //partToProduct: this.$scope.partToProduct,
          parentScope: this.$scope
        },
      })
    }
         

  }

}

